module.exports = __webpack_public_path__ + "img/redes-icono-facebook.e3ed12f1.svg";